module glossar {
  'use strict';

  

	/**
	 * The main controller for the app. The controller:
	 * - retrieves and persists the model via the todoStorage service
	 * - exposes the model to the template and provides event handlers
	 */
  export class GlossarCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$location',
      '$anchorScroll', 
      '$http',
      '$element',
      'pageMetaService',
      'parallaxService',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IGlossarScope,
      private $location: ng.ILocationService,
      private $anchorScroll: any, //ng.IAnchorScrollService
      private $http: ng.IHttpService, //angular.animate.IAnimateService,
      private $element: JQuery,
      private pageMetaService: navigation.IPageMetaService,
      private parallaxService: navigation.IParallaxService,
      ) {

      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      $scope.letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      $scope.selectedLetter = $scope.letters[0];

      //load mathjax
      if (!(<any>window).MathJax) {
        var head = document.getElementsByTagName("head")[0], script;
        script = document.createElement("script");
        script.type = "text/x-mathjax-config";
        script[((<any>window).opera ? "innerHTML" : "text")] =
          "MathJax.Hub.Config({\n" +
          "  tex2jax: { inlineMath: [['$','$'], ['\\\\(','\\\\)']] }\n" +
          "});";
        head.appendChild(script);
        script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "/library/public/MathJax/MathJax.js?config=TeX-AMS-MML_HTMLorMML";
        head.appendChild(script);
      }


      var elIndex :JQuery, elPageHead :JQuery, elHeader :JQuery, elIndexParent: JQuery;

     this.parallaxService.subscribeOnScroll($scope, (e: ng.IAngularEvent, scrollTop : number) =>  {

        elIndex = elIndex || $(this.$element).find(".index");
        elPageHead  = elPageHead || $(".pagehead");
        elHeader = elHeader || $(".glossar h3");

        if (!elIndex) return;

        elIndexParent = elIndexParent || elIndex.parent();


        if (elHeader && elHeader.offset().top == 0) return;
          
        if (!elIndexParent.hasClass("fixed") && (elIndex.offset().top - scrollTop) < elPageHead.height()) {
          elIndexParent.addClass("fixed");
        } 

        if (elIndexParent.hasClass("fixed")) {
          var pos = elHeader.offset().top + elHeader.outerHeight() - scrollTop;
          if (pos > elPageHead.height()) {
            elIndexParent.removeClass("fixed");
          }
        }

      });
      
      
  
      this.$http<GlossaryEntry[]>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Glossary"
        , headers: { 'Content-Type': 'application/json' }
        , params: { }
        , data: {
        }
      }).then((response : { data: GlossaryEntry[] }) => {
        $scope.index = response.data;

        $scope.letters = [];
        response.data.forEach((entry : GlossaryEntry) => {
          if ($scope.letters.indexOf(entry.IndexLetter) < 0) {
            $scope.letters.push(entry.IndexLetter);
          }
        });

      });

    }

    loadLetter(letter) {
      this.$scope.selectedLetter = letter;
      var scope :IGlossarScope = this.$scope;
    };

    loadEntry(entry : GlossaryEntry) {
      entry.Active = !entry.Active;
    }

  }

}
